import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, MenuController, Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './services/auth/auth.service';
import { CommonUtils } from './services/common-utils/common-utils';
import { take } from 'rxjs/operators';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})

export class AppComponent {

  main_url = environment.apiUrl;
  file_url = environment.fileUrl;

  // variable define
  url_name;
  url_path_name;
  get_user_type;
  panelOpenState: boolean;
  userInfodDataLoading;
  private userInfoSubscribe: Subscription;
  private groupMenuDataSubscribe : Subscription;
  private dashboardDataSubscribe: Subscription;
  menuPages = [];
  menuPagesList;
  menuPages2 = [];
  activeMenuHilight;
  selectedItemActive;
  parentSelectedIndex;
  childSelectedIndex;
  siteInfo : any;
  isActive : boolean = false;
  siteInfoLoading;
  get_user_dtls;
  viewData;
  sticky_url;
  toggle: boolean = false;

  constructor(
    private splashScreen: SplashScreen,
    private platform: Platform,
    private activatedRoute : ActivatedRoute,
    private http : HttpClient,
    private authService : AuthService,
    public menuCtrl: MenuController,
    public renderer: Renderer2,
    public router : Router,
    private alertController: AlertController,
    private commonUtils: CommonUtils, // common functionlity come here
    @Inject(DOCUMENT) private _document: HTMLDocument //use for fabicon
  ) {
    this.initializeApp();

    this.onSiteInformation();
    this.authService.autoLogin().pipe(
      take(1)
    ).subscribe(resData => {
    });
    

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  toggleMenu(_item) {
    if(_item == false) {
      this.toggle = true;
    }else{
      this.toggle = false;
    }
  }


  ngOnInit(){
    // User detailsls get
    this.authService.globalparamsData.subscribe(res => {
      
      if(res != null || res != undefined){
        this.get_user_dtls = res;
      }
    });
    this.backButtonEvent();
  }

  backButtonEvent() {
    this.platform.backButton.subscribe(() => {
        if (this.router.url === '/home') {
          this.presentAlertConfirm();
        } else {
          window.history.back();
        }
      // });
    });
  }

  // alert call
  async presentAlertConfirm() {
    const alert = await this.alertController.create({
      header: 'Exit App',
      message: 'Are you sure you want to exit?',
      cssClass: 'custom-alert2',
      buttons: [{
        text: 'No',
        role: 'cancel',
        cssClass: 'cancelBtn',
        handler: (blah) => { }
      }, {
        text: 'Yes',
        handler: () => {
          navigator['app'].exitApp();
        }
      }]
    });
    await alert.present();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      setTimeout(() => {
        this.splashScreen.hide();
      }, 3000); 
      // user data call
      this.userInfoData();
      
      // ----get current active url name start---
        this.activatedRoute.url.subscribe(activeUrl => {
          this.url_name = window.location.pathname;
        })
        
      //get current active url name end

      // observable data for all page url name get
      this.commonUtils.pagePathNameAnywhereObsv.subscribe(pathRes => {
        this.url_path_name = pathRes;
      });
      
      
    });
  }
  //------------------- menu item show get_user_dtlsstart------------------------


  

  // menu data call
  mapped;
  userInfoData(){


    this.menuPages = [];
    this.userInfodDataLoading = false;

    this.authService.globalparamsData.subscribe(res => {

      this.menuPages = [];

      
    });
  }

  closeModal() {
    this.menuCtrl.toggle();
  }

  // ============site information get start =============
  site_path;
  site_href;
  site_href_split;
  site_path_split;
  site_url_name;
  onSiteInformation(){

    this.site_path = window.location.pathname;
    this.site_href = window.location.href;
    this.site_href_split = window.location.href.split('/')[1];
    this.site_path_split = window.location.pathname.split('/')[1];

    // server print reasult///////
    /* site_path > /ci/xcelero/online/ 
    site_href > https://demo.rnjcs.in/ci/xcelero/online/#/auth 
    site_href_split > 
    site_path_split > ci  */

    const parsedUrl = new URL(window.location.href);
    const baseUrl = parsedUrl.hostname;
    if(baseUrl == 'localhost' || baseUrl == '192.168.1.218'){
      this.site_url_name = 'https://www.marketing-crm.bongtechsolutions.com/';
    }else{
      this.site_url_name = window.location.href;
    }

    this.siteInfoLoading = true;
    
  }
}